module.exports = __webpack_public_path__ + "img/tick-shop.01839d73.svg";